export class Transform{
    property: string;
    transform: (data: any) => string;
}
  